export const normalizeNumber = (value, minValue, maxValue) => {
  if (value < minValue) {
    return 0;
  }
  if (value > maxValue) {
    return 1;
  }
  return (value - minValue) / (maxValue - minValue);
};